import Vue from 'vue'
import VueRouter from 'vue-router'
import B2BReferralInfo from '../views/b2b/referral_info.vue'
import B2CReferralInfo from '../views/b2c/referral_info.vue'

Vue.use(VueRouter)

// While publishing make sure comment 1 of below DICT
const routes = [
  {
    path: '/code/:id',
    name: 'b2b-referral-info',
    component: B2BReferralInfo
  },
  {
    path: '/code/:id',
    name: 'b2c-referral-info',
    component: B2CReferralInfo
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
